import { render } from "./LongCollapsableText.vue?vue&type=template&id=6bfaf621&scoped=true"
import script from "./LongCollapsableText.vue?vue&type=script&lang=js"
export * from "./LongCollapsableText.vue?vue&type=script&lang=js"

import "./LongCollapsableText.vue?vue&type=style&index=0&id=6bfaf621&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfaf621"]])

export default __exports__